export { StandardTabs } from './StandardTabs';
